import { useTranslation } from 'react-i18next';

export function Translator(path) {
  const { t } = useTranslation();

  return t(path);
}
